import React from "react";
import {GraphiQLWrapper} from "../../components/graphql/GraphiQLWrapper";
import {WorkbenchStateContext} from "../../components/context/WorkbenchContext";
import {Endpoints} from '../../types/Configurations';
import ContentBlocker from "../../components/context/ContentBlocker";

import "./GraphQLPage.scss";

class GraphQLPage extends React.Component {

  static contextType = WorkbenchStateContext;

  render() {
    const endpoints = this.context.configurations.endpoints?.graphql || {};
    const graphqlEndpoints: Endpoints = {};
    Object.keys(endpoints).forEach((key) => {
      graphqlEndpoints[key] = {
        endpoint: key, label: endpoints[key].label
      };
    });
    return (
      <div className="GraphQLPage">
        <h1>GraphQL</h1>
        <ContentBlocker>
          <GraphiQLWrapper endpoints={graphqlEndpoints}/>
        </ContentBlocker>
      </div>
    );
  }
}

export default GraphQLPage;
